
import React, { Component } from 'react';

import { PvBox, ShadowedBox, ErrorLabel } from 'styles/CustomComponents';
import { PvCheckbox } from 'components/form/PvCheckbox';
import { Container, Flex, Label, Text } from 'rebass';
import { Translate } from 'react-redux-i18n';
import { getLabel, lessonTypes } from "../../util/SearchUtil";
import WizardActions from 'components/WizardActions';
import PropTypes from 'prop-types';
import { formatShortLessonDescription } from '../../util/FormatUtil';
import { LessonTypeIcon } from '../../util/IconUtil';

class EditLesson extends Component {
  constructor(props) {
    super(props);
    this.state = { showRemovalModal: false };
  }

  render() {

    const {
      lesson,
      loadingLesson,
      clearEdit,
    } = this.props;




    return (
      <Container>
        <ShadowedBox>
          <PvBox px={3} py={3}>
            <PvBox my={3}>
              <PvBox my={3}>
                <Flex flexWrap='wrap'>
                  <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 6]}>
                    <ErrorLabel mb={2}>
                      <Translate value='edit_lesson.lesson_type' />
                    </ErrorLabel>
                    <Label>
                      <LessonTypeIcon type={lesson.lessonType} />
                      <Text ml={2}>{getLabel(lesson.lessonType, lessonTypes())}</Text>
                    </Label>
                  </PvBox>
                  <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 6]}>
                    <ErrorLabel mb={2}>
                      <Translate value='edit_lesson.description_short' />
                    </ErrorLabel>
                    <Text>{!!lesson.description ? formatShortLessonDescription(lesson.description) : ''}</Text>
                  </PvBox>
                  <PvBox display='inline-block' px={2} pb={3} w={[1, 1, 4 / 6]}>
                    <ErrorLabel mb={2}>
                      <Translate value='edit_lesson.description' />
                    </ErrorLabel>
                    <Text>{!!lesson.description ? lesson.description : ''}</Text>
                  </PvBox>
                </Flex>
              </PvBox>

            </PvBox>
            <PvBox my={3}>

              <PvBox minWidth='19em' display='inline-block' px={2} pb={3}>
                <ErrorLabel mb={2}>
                  <Translate value='edit_lesson.exam_classes' />
                </ErrorLabel>
                <Text>{lesson.examClasses.map(ec => ec.name || ec).join(", ")}</Text>
              </PvBox>
            </PvBox>
            <PvBox my={3}>
              <Flex flexWrap='wrap' alignItems='flex-end'>
                <PvBox display='inline-block' px={2} pb={3} w={[1, 1, 3 / 5]}>
                  <ErrorLabel mb={2}>
                    <Translate value='edit_lesson.topic' />
                  </ErrorLabel>
                  <Text>{!!lesson.topic ? lesson.topic : ''}</Text>
                </PvBox>
                <PvBox display='inline-block' px={2} pb={3} w={[1, 1, 1 / 6]}>
                  <ErrorLabel mb={2}>
                    <Translate value='edit_lesson.order_number' />
                  </ErrorLabel>
                  <Text>{!!lesson.orderNumber ? lesson.orderNumber : ''}</Text>
                </PvBox>
              </Flex>
            </PvBox>
            <PvBox my={3}>
              <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
                <Label mb={2}>
                  <PvCheckbox type="checkbox"
                    defaultChecked={lesson.requiredForIndependentTraining}
                    disabled
                  />
                  <Translate style={{ paddingLeft: '1em' }} value='edit_lesson.independent_training' />
                </Label>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
                <Label mb={2}>
                  <PvCheckbox type="checkbox"
                    defaultChecked={lesson.requiredForPersonTransport}
                    disabled
                  />
                  <Translate style={{ paddingLeft: '1em' }} value='edit_lesson.person_transport' />
                </Label>
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
                <Label mb={2}>
                  <PvCheckbox type="checkbox"
                    defaultChecked={lesson.additionalLesson === undefined ? false : lesson.additionalLesson}
                    disabled
                  />
                  <Translate style={{ paddingLeft: '1em' }} value='edit_lesson.additional_lesson' />
                </Label>
              </PvBox>
            </PvBox>
          </PvBox>
        </ShadowedBox>
        <WizardActions loading={loadingLesson}
          nextDisabled={true} previousFn={clearEdit} />
      </Container>
    );
  }
}

EditLesson.props = {
  lesson: PropTypes.object,
  examClasses: PropTypes.array,
  loadingLesson: PropTypes.bool,
  saveLesson: PropTypes.func,
  clearEdit: PropTypes.func,
  updateLesson: PropTypes.func,
  removeLesson: PropTypes.func,
};

export default EditLesson;




// WEBPACK FOOTER //
// ./src/containers/lessonsEdit/editLesson.js